module.exports = __webpack_public_path__ + "static/img/110.f72efd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/110.jpg
// module id = ZMSg
// module chunks = 2